<script lang="ts">
export default {
  name: 'Watermark'
}
</script>
<script lang="ts" setup>
import { computed, onBeforeUnmount, onMounted, reactive } from 'vue'
import { useUserStore } from '@/store/modules/user'

const options = {
  /** 文字颜色 */
  color: '#000',
  /** 文字大小 */
  fontSize: 14,
  /** 透明度 */
  opacity: 0.1,
  /** 文字水平方向间距 */
  spaceX: 160,
  /** 文字垂直方向间距 */
  spaceY: 120,
  /** 旋转角度 */
  textRotate: -22,
  /** 文字字体 */
  fontFamily: 'Helvetica, Arial, sans-serif'
}

/** 文本宽高（固定） */
const textAttr = {
  width: 100,
  height: 20
}

const width = options.spaceX + textAttr.width
const height = options.spaceY + textAttr.height
const height2 = height * 2
const widthHalf = width / 2
const rotate = `rotate(${options.textRotate})`
const textStyle = `font-family: ${options.fontFamily}; font-size: ${options.fontSize}; fill: ${options.color}; fill-opacity: ${options.opacity}`

const position = reactive({
  top: 0,
  left: 0,
  width: '100%',
  height: '100%'
})

const userStore = useUserStore()

const markText = computed(() => {
  const userName = userStore.getUserInfo?.uname ?? ''
  const account = userStore.getAccount ?? ''
  return `${userName}${account}`
})

const visible = computed(() => Boolean(markText.value.trim()))

const calcPosition = () => {
  position.top = 0
  position.left = 0
  position.width = `${window.innerWidth}px`
  position.height = `${window.innerHeight}px`
}

onMounted(() => {
  calcPosition()
  window.addEventListener('resize', calcPosition)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', calcPosition)
})
</script>

<template>
  <svg
    v-if="visible"
    :style="position"
    class="watermark"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="none"
  >
    <defs>
      <pattern
        id="watermark-pattern1"
        x="0"
        y="0"
        :width="width"
        :height="height2"
        patternUnits="userSpaceOnUse"
        :patternTransform="rotate"
      >
        <text x="0" :y="options.fontSize" :style="textStyle">
          {{ markText }}
        </text>
      </pattern>
      <pattern
        id="watermark-pattern2"
        :x="widthHalf"
        :y="height"
        :width="width"
        :height="height2"
        patternUnits="userSpaceOnUse"
        :patternTransform="rotate"
      >
        <text x="0" :y="options.fontSize" :style="textStyle">
          {{ markText }}
        </text>
      </pattern>
    </defs>
    <rect x="0" y="0" width="100%" height="100%" style="fill: url(#watermark-pattern1); fill-opacity: 1" />
    <rect x="0" y="0" width="100%" height="100%" style="fill: url(#watermark-pattern2); fill-opacity: 1" />
  </svg>
</template>

<style lang="scss" scoped>
.watermark {
  position: fixed;
  pointer-events: none;
  z-index: 10001;
}
</style>
